export default "__VITE_ASSET__CvjjM67k__"